<template>
  <div class="total-indemnity-filter">
    <label class="d-block mb-1">Cash Call Amount</label>

    <div class="d-flex align-items-center">
      <!-- FROM -->
      <input
        type="text"
        class="form-control form-control-sm mr-2 indemnity-input"
        placeholder="From"
        :value="fromDisplayValue"
        @input="onFromInput($event.target.value)"
        @focus="onFromFocus"
        @blur="onFromBlur"
      />


      <!-- TO -->
      <input
        type="text"
        class="form-control form-control-sm ml-2 indemnity-input"
        placeholder="To"
        :value="toDisplayValue"
        @input="onToInput($event.target.value)"
        @focus="onToFocus"
        @blur="onToBlur"
      />
    </div>

    <!-- Validation error -->
    <div v-if="error" class="text-danger small mt-1">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref, watch } from '@vue/composition-api'

export default defineComponent({
  name: "CashCallManagementTableFiltersTotalIndemnity",

  props: {
    value: {
      type: Object,
      default: () => ({ from: null, to: null })
    }
  },

  emits: ["input"],

  setup(props, { emit }) {
    const error = ref("");
    const fromEditing = ref(false);
    const toEditing = ref(false);
    const fromRawValue = ref("");
    const toRawValue = ref("");

    // --- FORMATTER: turns 1000 into 1,000.00 ---
    const formatCurrency = (val) => {
      if (val === null || val === "" || isNaN(val)) return "";
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(parseFloat(val));
    };

    const unformatCurrency = (val) => {
      if (!val) return null;
      const cleaned = val.replace(/[^0-9.]/g, "");
      if (cleaned === "" || cleaned === ".") return null;
      return parseFloat(cleaned);
    };

    const fromDisplayValue = computed(() => {
      if (fromEditing.value) return fromRawValue.value;
      return formatCurrency(props.value.from);
    });

    const toDisplayValue = computed(() => {
      if (toEditing.value) return toRawValue.value;
      return formatCurrency(props.value.to);
    });

    const validate = (from, to) => {
      if (from != null && to != null && from > to) {
        error.value = "From amount cannot exceed To amount.";
      } else {
        error.value = "";
      }
    };

    const onFromInput = (rawValue) => {
      fromRawValue.value = rawValue;
      const clean = unformatCurrency(rawValue);
      const newVal = { ...props.value, from: clean };
      validate(newVal.from, newVal.to);
      emit("input", newVal);
    };

    const onToInput = (rawValue) => {
      toRawValue.value = rawValue;
      const clean = unformatCurrency(rawValue);
      const newVal = { ...props.value, to: clean };
      validate(newVal.from, newVal.to);
      emit("input", newVal);
    };

    const onFromFocus = () => {
      fromEditing.value = true;
      fromRawValue.value = props.value.from != null ? String(props.value.from) : "";
    };

    const onFromBlur = () => {
      fromEditing.value = false;
    };

    const onToFocus = () => {
      toEditing.value = true;
      toRawValue.value = props.value.to != null ? String(props.value.to) : "";
    };

    const onToBlur = () => {
      toEditing.value = false;
    };

    return {
      fromDisplayValue,
      toDisplayValue,
      onFromInput,
      onToInput,
      onFromFocus,
      onFromBlur,
      onToFocus,
      onToBlur,
      error
    };
  }
});
</script>

<style scoped>
.total-indemnity-filter input {
  width: 120px;
}
.indemnity-input {
  max-width: 110px; 
  height: 30px; 
  padding: 2px 6px;
  font-size: 12px;
}

</style>
